<template>
  <v-container>
    <v-card class="pa-16">
      <v-row>
        <v-col cols="12" md="2">
          <v-autocomplete v-model="customer_code" :items="customer" item-text="cust_account" item-value="cust_account"
            outlined @change="onSelectCustomerCodeChange(customer_code)" dense disabled
            label="Client Code"></v-autocomplete>
        </v-col>

        <v-col cols="12" md="6">
          <v-autocomplete v-model="customer_name" :items="customer_list" item-text="name" item-value="id" outlined
            @change="onSelectCustomerChange(customer_name)" dense disabled label="Client Name"></v-autocomplete>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field v-model="saleorder_id" outlined dense label="Sales Orders No." background-color="#F5F5F5"
            disabled></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8">
          <v-text-field v-model="invoice_address" outlined dense label="Invoice Address" background-color="#F5F5F5"
            disabled></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="currency" outlined dense label="Currency" background-color="#F5F5F5"
            disabled></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field v-model="tax_id" outlined dense label="Tax ID " background-color="#F5F5F5"
            disabled></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <v-text-field v-model="branch" outlined dense label="Branch" background-color="#F5F5F5"
            disabled></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field @change="onSelectpayment()" v-model="payment_term" outlined dense :disabled="datainv_disable"
            label="Payment Term (Day)"></v-text-field>
        </v-col>

        <v-col cols="12" sm="3">
          <v-text-field @change="onSelectvat()" v-model="vat" @keyup="calvatAll(vat)" outlined dense
            :disabled="datainv_disable" label="Vat (%)"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field @change="onSelectpono()" v-model="po_no" outlined dense :disabled="datainv_disable"
            label="PO NO."></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field @change="onSelectattention()" v-model="attention" outlined dense :disabled="datainv_disable"
            label="Attention"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field @change="onSelectcontact_position()" v-model="contact_position" outlined dense
            :disabled="datainv_disable" label="Contact Position"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-select @change="onSelectvat_type()" outlined :items="vat_type_list" v-model="vat_type" item-value="id"
            item-text="name" label="Vat Type" dense :disabled="datainv_disable"></v-select>
        </v-col>
      </v-row>

      <br />

      <template>
        <v-data-table :headers="headers" :items="desserts" class="elevation-1 595959">
          <template v-slot:[`item.unit`]="{ item }">
            <span>
              {{
                item.unit.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </template>
          <template v-slot:[`item.PricePerUnit`]="{ item }">
            <span>
              {{
                item.PricePerUnit.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </template>
          <template v-slot:[`item.amount`]="{ item }">
            <span>
              {{
                item.amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </span>
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
              Reset
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon> -->

            <v-icon :style="{
              backgroundColor: '#E1F5FE',
              color: '#2196F3',
            }" :disabled="datainv_disable" @click="openeditItem(item)">
              mdi-pencil
            </v-icon>

            <v-icon class="ml-2" :style="{
              backgroundColor: '#FFEBEE',
              color: '#F44336',
            }" :disabled="datainv_disable" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </template>

      <div v-if="!datainv_disable" :style="{
        display: !datainv_disable ? 'show' : 'none',
      }" class="pl-2 pr-2 pt-2 elevation-1 heightsize55formadvance">
        <template v-if="this.datainv_h.dept_type == 'IM' || this.datainv_h.dept_type == 'IP'">
          <v-row>
            <v-col cols="12" xl="1" lg="1" md="1" sm="1" style="margin-left: 1rem; padding: 0.5rem 0 0 1rem;">
              <v-checkbox label="Header" style="height: 30px;" v-model="editedItemadd.headercheckbox"
                @change="onSelectHeaderChange(editedItemadd.headercheckbox)"></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="1" md="1"> </v-col>
            <v-col cols="12" xl="4" lg="4" md="4" sm="4" style="padding-right: 0;">
              <v-autocomplete :disabled="datainv_disable" v-model="editedItemadd.inv_title" :items="inv_title_list"
                item-text="title" item-value="title" ref="inv_titleref" label="Select" outlined dense
                style="width: 97%;" @change="
                  onSelectmiscellaneous_disbursementsChange(
                    editedItemadd.inv_title
                  )
                  " @keydown.enter="changeFocusText(2)"></v-autocomplete>
              <!-- <v-text-field
                v-model="editedItemadd.description"
                ref="txtDescription"
                dense
                outlined
                label="Sevice/Description"
              ></v-text-field> -->
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="2" style="padding-left: 0; padding-right: 0; max-width: 15%;">
              <v-btn v-if="editedItemadd.headercheckbox" depressed @click="save()" color="#0A7EA5" dark class="mb-2">
                Add
              </v-btn>
              <!--     min="0" -->
              <v-text-field v-else v-model="editedItemadd.unit" ref="txtunit" label="Qty" type="number" dense outlined
                style="width: 90%;"></v-text-field>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="2" style="padding-left: 0;">
              <!--   min="0" -->
              <v-text-field v-if="!editedItemadd.headercheckbox" v-model="editedItemadd.PricePerUnit"
                ref="txtPricePerUnit" label="Price per Unit" type="number" dense outlined style="width: 90%;"
                @keydown.tab="save()" @keydown.enter="save()"></v-text-field>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3">
              <v-btn v-if="!editedItemadd.headercheckbox" depressed @click="save()" color="#0A7EA5" dark class="mb-2">
                Add
              </v-btn>
            </v-col>
          </v-row>
          <!-- v-if="editedItemadd.inv_title == 'Others'" -->
          <v-row>
            <v-col cols="12" sm="1" md="1"> </v-col>
            <v-col cols="12" sm="4" md="4" class="mt-n10">
              <v-text-field v-model="editedItemadd.description" ref="txtDescription" dense outlined
                label="Sevice/Description" persistent-hint hint="** ข้อมูลจะต่อจาก select ด้านบนที่เลือก ยกเว้น Others"
                class="hintcolorred"></v-text-field>
            </v-col>
            <v-col cols="12" sm="7" md="7"> </v-col>
          </v-row>
        </template>

        <template v-else>
          <v-row>
            <v-col cols="12" xl="1" lg="1" md="1" sm="1"></v-col>
            <v-col cols="12" xl="4" lg="4" md="4" sm="4">
              <v-text-field v-model="editedItemadd.description" ref="txtDescription" dense outlined
                label="Sevice/Description"></v-text-field>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="2">
              <!--  min="0" -->
              <v-text-field v-model="editedItemadd.unit" ref="txtunit" label="Qty" type="number" dense
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="2">
              <!--   min="0" -->
              <v-text-field v-model="editedItemadd.PricePerUnit" ref="txtPricePerUnit" label="Price per Unit"
                type="number" dense outlined @keydown.tab="save()" @keydown.enter="save()"></v-text-field>
            </v-col>
            <v-col cols="12" xl="3" lg="3" md="3" sm="3"></v-col>
          </v-row>
        </template>
        <br />
      </div>

      <br />
      <br />
    </v-card>

    <v-dialog v-model="dialogEdit" max-width="800px">
      <v-card class="pa-8">
        <v-card-title class="text-h6">Service No.{{ dataeditItem.no }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-textarea v-model="dataeditItem.description" multi-line outlined dense
                label="Service Details"></v-textarea>
            </v-row>
            <v-row>
              <!-- <v-col cols="12" md="3">
                <v-text-field
                  reverse
                  v-model="dataeditItem.item_um"
                  outlined
                  dense
                  background-color="#F5F5F5"
                  disabled
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" md="4">
                <!-- min="0" -->
                <v-text-field type="number" label="Amount" @click="calserviceamount(dataeditItem)"
                  @keyup="calserviceamount(dataeditItem)" v-model="dataeditItem.unit" outlined dense></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field type="number" label="Price Per Unit" v-model="dataeditItem.PricePerUnit" outlined dense
                  :disabled="isdisableeditpriceperunit"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field type="number" label="Total Price" v-model="dataeditItem.amount" outlined dense
                  background-color="#F5F5F5" disabled></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed width="100" class="mr-3 buttonblue" @click="saveeditItem()">
            Save
          </v-btn>
          <v-btn depressed outlined width="100" @click="closeeditItem()">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    /> -->
    <SuccessDialogInvoiceFreetext_So :status="dialogAddSo" :text_color="text_colorSo" :title="titleSo"
      :message="messageSo" />
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogInvoiceFreetext_So from "@/components/cards/SuccessDialogInvoiceFreetext_So";
import api from "@/services/api";
import { server } from "@/services/constants";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";

export default {
  name: "InvoiceSalseorderTab",
  props: [
    "so_id",
    "datainv_h",
    "datainv_so",
    "datainv_disable",
    "vat_cus",
    "payment_term_cus",
    "po_no_cus",
    "attention_cus",
    "contact_position_cus",
    "vat_type_cus",
  ],
  // async beforeUpdate() {
  //   if (this.datainv_h.customerid != 0) {
  //     await this.loaddataSO();
  //   } else {
  //   }
  // },
  async beforeMount() {
    this.$showLoader();
    await this.loaddataSO();
    if (this.datainv_h.dept_type == "IM") {
      this.isdisableeditpriceperunit = false;
      await this.loadinv_titlelist();
    }
    if (this.datainv_h.dept_type == "IP") {
      this.isdisableeditpriceperunit = false;
      await this.loadip_pricelist();
    }
    if (this.datainv_h.dept_type == "FreeText") {
      this.isdisableeditpriceperunit = false;
    }
  },
  async mounted() {

    // await this.loaddataSO();
    // await this.loadCustomer();
    await this.loadCustomer();
    if (this.po_no_cus != "") {
      this.po_no = this.po_no_cus;
    }
    if (this.attention_cus != "") {
      this.attention = this.attention_cus;
    }
    if (this.contact_position_cus != "") {
      this.contact_position = this.contact_position_cus;
    }
    if (this.vat_type_cus != "") {
      this.vat_type = this.vat_type_cus;
    }
    if (this.vat_cus != 0) {
      this.vat = this.vat_cus;
    }
    if (this.payment_term_cus != 0) {
      this.payment_term = this.payment_term_cus;
    }
    if (this.status_loadso == 0) {
      // this.vat_cus = this.datainv_h.customer_vat;
      this.vat = this.datainv_h.customer_vat;

      // this.payment_term_cus = this.datainv_h.customer_paymentterm;
      this.payment_term = this.datainv_h.customer_paymentterm;

      // this.po_no_cus = this.datainv_h.po_no;
      this.po_no = this.datainv_h.po_no;

      // this.attention_cus = this.datainv_h.attention;
      this.attention = this.datainv_h.attention;

      this.contact_position_cus = this.datainv_h.contact_position;
      // this.vat_type_cus = this.datainv_h.vat_type;

      this.vat_type = this.datainv_h.vat_type;
      this.$emit("inv_sotab_paymentcus", this.payment_term);
      this.$emit("inv_sotab_vatcus", this.vat);
      this.$emit("inv_sotab_ponocus", this.po_no);
      this.$emit("inv_sotab_attentioncus", this.attention);
      this.$emit("inv_sotab_contact_positioncus", this.contact_position);
      this.$emit("inv_sotab_vat_type", this.vat_type);
      this.status_loadso = 1;
    }
    if (this.datainv_h.dept_type == "IM") {
      this.isdisableeditpriceperunit = false;
      await this.loadinv_titlelist();
    }
    if (this.datainv_h.dept_type == "IP") {
      this.isdisableeditpriceperunit = false;
      await this.loadip_pricelist();
    }
    if (this.datainv_h.dept_type == "FreeText") {
      this.isdisableeditpriceperunit = false;
    }
  },
  components: {
    SuccessDialog,
    SuccessDialogInvoiceFreetext_So,
  },
  data() {
    return {
      vat_type_list: [{ id: "I", name: "Include Vat" }, { id: "E", name: "Exclude Vat" }],
      isdisableeditpriceperunit: true,
      inv_title_list: [],
      status_loadso: 0,
      editedIndex: -1,
      dataeditItem: {
        no: 0,
        description: "",
        unit: 0,
        item_um: "",
        PricePerUnit: 0,
        amount: 0,
      },
      dialogEdit: false,
      dialogDelete: false,
      isShowPassword: false,
      fullPage: true,
      customer: [],
      customer_list: [],
      customer_code: "",
      customer_id: "",
      customer_name: "",
      saleorder_id: "",
      currency: "",
      tax_id: "",
      branch: "",
      invoice_address: "",
      payment_term: 0,
      vat: 0,
      po_no: "",
      attention: "",
      contact_position: "",
      vat_type: "",
      vatCal: 0,
      desserts: [],
      editedItem: {
        code: "",
        description: "",
        amount: 0,
      },
      editedItemadd: {
        headercheckbox: false,
        inv_title: "",
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        PricePerUnit: 0,
      },
      defaultItem: {
        headercheckbox: false,
        inv_title: "",
        description: "",
        no: 0,
        unit: 0,
        amount: 0,
        PricePerUnit: 0,
      },
      // dialogAdd: false,
      dialogSendMail: false,
      // text_color: "text-h5 green--text text-center",
      // title: "green",
      // message: "green",
      headers: [
        {
          text: "No.",
          value: "no",
          class: "bg-colorth texttablehcenter ",
          width: "8%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Service Details",
          value: "description",
          class: "bg-colorth texttablehcenter",
          width: "30%",
          align: "start",
          divider: true,
          sortable: false,
        },
        {
          text: "Qty",
          value: "unit",
          class: "bg-colorth texttablehcenter ",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },
        // {
        //   text: "Unit",
        //   value: "item_um",
        //   class: "bg-colorth texttablehcenter ",
        //   width: "10%",
        //   divider: true,
        //   align: "end",
        //   sortable: false,
        // },
        {
          text: "Price Per Unit",
          value: "PricePerUnit",
          class: "bg-colorth texttablehcenter",
          width: "14%",
          divider: true,
          align: "end",
          sortable: false,
        },
        {
          text: "Total Price",
          value: "amount",
          class: "bg-colorth texttablehcenter",
          width: "15%",
          divider: true,
          align: "end",
          sortable: false,
        },

        {
          value: "actions",
          class: "bg-colorth texttablehcenter",
          align: "center",
          width: "13%",
          divider: true,
          sortable: false,
        },
      ],
      dialogAddSo: false,
      text_colorSo: "text-h5 green--text text-center",
      titleSo: "green",
      messageSo: "green",
    };
  },
  methods: {
    async loadip_pricelist() {
      // const result = await api.getIPPriceListForInvSo();
      const result = await api.billing_expense_getInvTitleByDep(localStorage.getItem(server.DEPARTMENT_ID));
      this.inv_title_list = result.data;
      this.inv_title_list.push({ title: "Others", price: 0 });
    },
    async loadinv_titlelist() {
      const result = await api.billing_expense_getInvTitleByDep(localStorage.getItem(server.DEPARTMENT_ID));

      this.inv_title_list = result.data;
      this.inv_title_list.push({ title: "Others", price: 0 });
    },
    async onSelectHeaderChange(headercheckbox) {
      this.editedItemadd.unit = 0;
      this.editedItemadd.PricePerUnit = 0;
    },
    async onSelectmiscellaneous_disbursementsChange(inv_title) {
      this.inv_title_list.filter((item) => {
        if (item.title == inv_title) {
          this.editedItemadd.unit = 1;
          this.editedItemadd.PricePerUnit = item.price;
        }
      });
    },
    save() {


      if (this.editedItemadd.headercheckbox) {
        this.editedItemadd.unit = 0;
        this.editedItemadd.PricePerUnit = 0;
      } else {
      }
      if (this.customer_code == "") {
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณาเลือก Client",
          "text-h5 red--text text-center"
        );
        return;
      }


      if (
        !this.editedItemadd.headercheckbox &&
        (this.editedItemadd.unit == undefined ||
          this.editedItemadd.unit == "0" ||
          this.editedItemadd.unit == 0)
      ) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอกจำนวน Qty",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (!this.editedItemadd.headercheckbox && !this.editedItemadd.unit) {
        // alert("กรุณากรอกจำนวน");
        this.$store.state.global_global_dialog_invoicefreetext_sodialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอกจำนวน Qty",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }

      if (
        !this.editedItemadd.headercheckbox &&
        (this.editedItemadd.PricePerUnit == undefined ||
          this.editedItemadd.PricePerUnit == "0" ||
          this.editedItemadd.PricePerUnit == 0)
      ) {
        // alert("กรุณากรอกจำนวนเงินต่อหน่วย");
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอกจำนวน Price Per Unit",
          "text-h5 red--text text-center"
        );
        this.$refs["txtPricePerUnit"].focus();
        return;
      }

      if (this.editedItemadd.PricePerUnit < 0) {
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "จำนวน Price Per Unit ต้องมากกว่า 0",
          "text-h5 red--text text-center"
        );
        this.$refs["txtunit"].focus();
        return;
      }
      if (
        (this.datainv_h.dept_type == "IM" || this.datainv_h.dept_type == "IP") &&
        this.editedItemadd.inv_title !== "Others"
      ) {
        if (this.editedItemadd.inv_title == "") {
          this.$store.state.global_dialog_invoicefreetext_so = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "กรุณาเลือก select invoice title",
            "text-h5 red--text text-center"
          );
          return;
        }
        this.editedItemadd.description =
          this.editedItemadd.inv_title +
          (this.editedItemadd.description != "" ||
            this.editedItemadd.description != undefined ||
            this.editedItemadd.description != null
            ? this.editedItemadd.description
            : "");
      } else {
      }
      if (
        this.editedItemadd.inv_title == "Others" &&
        (this.editedItemadd.description == "" ||
          this.editedItemadd.description == null)
      ) {
        this.$store.state.global_dialog_invoicefreetext_so = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "กรุณากรอก Description/Service",
          "text-h5 red--text text-center"
        );
        this.$refs["txtDescription"].focus();
        return;
      }

      // if (this.editedIndex > -1) {
      //     Object.assign(this.desserts[this.editedIndex], this.editedItemadd);
      // } else {

      // }
      if (this.desserts.length == 0) {
        this.desserts.push(this.editedItemadd);
      } else {
        let getolddesserts = [];
        for (let i = 0; i < this.desserts.length; i++) {
          if (this.editedItemadd.unit == 0 && this.editedItemadd.PricePerUnit == 0) {
            if (stringcommatonumber(this.desserts[i].unit.toString()) > 0 && stringcommatonumber(this.desserts[i].PricePerUnit.toString()) > 0) {
              getolddesserts = [
                ...this.desserts.slice(0, i),
                this.editedItemadd,
                ...this.desserts.slice(i)
              ];
              this.desserts = getolddesserts;
              break;
            }
            else {
              if (i == this.desserts.length - 1) {
                this.desserts.push(this.editedItemadd);
                break;
              }

            }
          } else {
            this.desserts.push(this.editedItemadd);
            break;
          }
        }
      }

      this.sumtotal = 0;
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });
      this.sumtotal = this.sumtotal.toFixed(2);
      this.$store.state.inv_so_total = this.sumtotal;
      this.$emit("inv_sotab_isheader", this.sumtotal);
      this.$emit("inv_sotab_tabledesserts", this.desserts);
      this.close();
      this.$refs["txtDescription"].focus();
      this.editedItemadd = Object.assign({}, this.defaultItem);
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItemadd = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async loaddataSO() {

      if (this.datainv_h.customerid != 0) {

        this.customer_code = this.datainv_h.customer_code;
        this.customer_id = this.datainv_h.customerid;
        this.customer_name = this.datainv_h.customer_name;
        this.saleorder_id = this.datainv_h.saleorder_id;
        this.currency = this.datainv_h.currency;
        this.invoice_address = this.datainv_h.customer_address;
        this.payment_term = this.datainv_h.customer_paymentterm;
        this.branch = this.datainv_h.branch;
        this.tax_id = this.datainv_h.customer_taxid;
        this.vat = this.datainv_h.customer_vat;
        this.vatCal = this.datainv_h.customer_vat;
        this.po_no = this.datainv_h.po_no;
        this.attention = this.datainv_h.attention;
        this.contact_position = this.datainv_h.contact_position;
        this.vat_type = this.datainv_h.vat_type;

        if (this.datainv_so.length > 0) {

          this.desserts = this.datainv_so;
          let testsumso = 0;
          this.sumtotal = 0;

          // this.desserts.forEach((item, index) => {
          //   item.no = index + 1;
          //   item.unit = stringcommatonumber(item.unit.toString());
          //   item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
          //   item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
          //   this.sumtotal += parseFloat(item.amount, 10);
          //   item.unit = tolocalestringnumber(item.unit);
          //   item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
          //   item.amount = tolocalestringnumber(item.amount);
          // });
          this.desserts.forEach((item, index) => {
            item.no = index + 1;



            const unit = Number(item.unit);
            const price = Number(item.priceperunit);
            const amount = unit * price;


            this.sumtotal += amount;

            // ค่าจริง
            item.unit_value = unit;
            item.price_value = price;
            item.amount_value = amount;

            // ค่าแสดงผล
            item.unit = tolocalestringnumber(unit);
            item.PricePerUnit = tolocalestringnumber(price);
            item.amount = tolocalestringnumber(amount.toFixed(2));
          });

          this.sumtotal = this.sumtotal.toFixed(2);
          this.$store.state.inv_so_total = this.sumtotal;
          this.$emit("inv_sotab_isheader", this.sumtotal);
          this.$emit("inv_sotab_tabledesserts", this.desserts);
        } else {
          let testsumso = 0;
          this.$emit("inv_sotab_isheader", testsumso);
          this.$emit("inv_sotab_tabledesserts", this.desserts);
        }

      } else {
        const res_h = await api.billing_expense_getAllSOById(this.so_id);
        const res_d = await api.billing_expense_getAlldetailSOById(this.so_id);

        if (res_h.data.length > 0) {
          let dataso_h = res_h.data[0];
          this.customer_code = dataso_h.customer_code;
          this.customer_id = dataso_h.customer_id;
          this.customer_name = dataso_h.name;
          this.invoice_address = dataso_h.customer_inv_address;
          this.payment_term = dataso_h.payment_term;
          this.branch = dataso_h.branch;
          this.vat = dataso_h.vat;
          this.vatCal = dataso_h.sum_tax;
          this.tax_id = dataso_h.tax_id;
          this.po_no = dataso_h.po_no;
          this.attention = dataso_h.attention;
          this.contact_position = dataso_h.contact_position;
          this.vat_type = dataso_h.vat_type;
          this.currency = dataso_h.currency;
          this.saleorder_id = dataso_h.saleorder_id;
          // console.log(this.customer_id)
          // console.log(dataso_h)
        }
        let testsumso = 0;
        this.desserts = res_d.data;

        this.sumtotal = 0;
        console.log(res_d.data)
        // this.desserts.forEach((item, index) => {
        //   item.no = index + 1;
        //   item.unit = stringcommatonumber(item.unit.toString());
        //   item.PricePerUnit = stringcommatonumber(item.PricePerUnit).toString();
        //   item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        //   this.sumtotal += parseFloat(item.amount, 10);
        //   item.unit = tolocalestringnumber(item.unit);
        //   item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        //   item.amount = tolocalestringnumber(item.amount);
        // });

        this.desserts.forEach((item, index) => {
          item.no = index + 1;



          const unit = Number(item.unit);
          const price = Number(item.priceperunit);
          const amount = unit * price;


          this.sumtotal += amount;

          // ค่าจริง
          item.unit_value = unit;
          item.price_value = price;
          item.amount_value = amount;

          // ค่าแสดงผล
          item.unit = tolocalestringnumber(unit);
          item.PricePerUnit = tolocalestringnumber(price);
          item.amount = tolocalestringnumber(amount.toFixed(2));
        });


        this.sumtotal = this.sumtotal.toFixed(2);
        if (localStorage.getItem(server.COMPANYID) && (localStorage.getItem(server.COMPANYID) == "1" || localStorage.getItem(server.COMPANYID) == 1)) {
          this.desserts.unshift({
            headercheckbox: true,
            inv_title: "",
            description: `TO OUR CHARGES for professional service rendered to ${this.customer_name} in connection with `,
            no: 1,
            unit: "0",
            amount: "0",
            PricePerUnit: "0",
          })
        }

        this.$emit(
          "inv_sotab_noheader",
          this.customer_id,
          this.invoice_address,
          this.tax_id,
          this.branch,
          this.payment_term,
          this.vat,
          this.vat_type,
          this.sumtotal,
          res_h.data[0].id
        );
        this.$store.state.inv_so_total = this.sumtotal;
        this.$emit("inv_sotab_isheader", this.sumtotal);
        this.$emit("inv_sotab_tabledesserts", this.desserts);
      }
    },

    async openeditItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dataeditItem.no = item.no;
      this.dataeditItem.description = item.description;
      this.dataeditItem.unit = item.unit;
      this.dataeditItem.item_um = item.item_um;
      this.dataeditItem.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
      this.dataeditItem.amount = item.amount;
      this.dialogEdit = true;
    },
    async saveeditItem() {
      // alert(this.desserts[this.editedIndex].unit);
      this.desserts[
        this.editedIndex
      ].description = this.dataeditItem.description;
      this.desserts[this.editedIndex].PricePerUnit = this.dataeditItem.PricePerUnit;
      this.desserts[this.editedIndex].unit = this.dataeditItem.unit;
      this.desserts[this.editedIndex].amount = this.dataeditItem.amount;
      // let testsumso = 0;
      // this.desserts.forEach((item, index) => {
      //   item.no = index + 1;
      //   testsumso += parseFloat(item.amount);
      // });
      this.sumtotal = 0;
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });
      this.sumtotal = this.sumtotal.toFixed(2);
      this.$store.state.inv_so_total = this.sumtotal;
      this.$emit("inv_sotab_isheader", this.sumtotal);
      this.$emit("inv_sotab_tabledesserts", this.desserts);
      this.dialogEdit = false;
    },
    async closeeditItem() {
      this.dialogEdit = false;
    },
    async calserviceamount(item) {
      this.dataeditItem.amount = parseFloat(
        item.unit * this.dataeditItem.PricePerUnit
      );
    },
    async loadCustomer() {
      let result = [];
      result = await api.getAllCustomerListactive();

      this.customer = result.data;

      result.data.forEach((item) => {
        this.customer_list.push(item.name);
      });
      this.$hideLoader();
    },

    onSelectCustomerCodeChange(code) {
      var tmp = null;
      tmp = this.customer.filter((c) => c.cust_account.includes(code));
      this.customer_name = tmp[0].name;
      this.customer_address = tmp[0].address;
      this.invoice_address = tmp[0].address_invoice;
      this.payment_term = tmp[0].payment_term;
      this.customer_code = tmp[0].cust_account;
      this.branch = tmp[0].branch;
      this.tax_id = tmp[0].taxid;
      this.po_no = tmp[0].po_no;
      this.attention = tmp[0].attention;
      this.contact_position = tmp[0].contact_position;
      this.vat_type = tmp[0].vat_type;
      this.vat = tmp[0].vat;
      this.vatCal = tmp[0].vat;
    },
    onSelectCustomerChange(search_customer) {
      var tmp = null;
      tmp = this.customer.filter((c) => c.name.includes(search_customer));
      this.invoice_address = tmp[0].address_invoice;
      this.payment_term = tmp[0].payment_term;
      this.customer_code = tmp[0].cust_account;
      this.branch = tmp[0].branch;
      this.tax_id = tmp[0].taxid;
      this.po_no = tmp[0].po_no;
      this.attention = tmp[0].attention;
      this.contact_position = tmp[0].contact_position;
      this.vat_type = tmp[0].vat_type;
      this.vat = tmp[0].vat;
      this.vatCal = tmp[0].vat;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.dialogDelete = true;
    },
    deleteItemConfirm(index) {
      this.desserts.splice(this.editedIndex, 1);
      let testsumso = 0;
      this.sumtotal = 0;
      this.desserts.forEach((item, index) => {
        item.no = index + 1;
        item.unit = stringcommatonumber(item.unit.toString());
        item.PricePerUnit = stringcommatonumber(item.PricePerUnit.toString());
        item.amount = parseFloat(item.unit * item.PricePerUnit).toFixed(2);
        this.sumtotal += parseFloat(item.amount, 10);
        item.unit = tolocalestringnumber(item.unit);
        item.PricePerUnit = tolocalestringnumber(item.PricePerUnit);
        item.amount = tolocalestringnumber(item.amount);
      });
      this.sumtotal = this.sumtotal.toFixed(2);
      this.$store.state.inv_so_total = this.sumtotal;
      this.$emit("inv_sotab_isheader", this.sumtotal);
      this.$emit("inv_sotab_tabledesserts", this.desserts);
      this.dialogDelete = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    async onSelectpayment() {
      this.$emit("inv_sotab_paymentcus", this.payment_term);
      // alert(this.payment_term)
    },
    async onSelectvat() {
      this.$emit("inv_sotab_vatcus", this.vat);
      // alert(this.vat)
    },
    async onSelectpono() {
      this.$emit("inv_sotab_ponocus", this.po_no);
      // alert(this.po_no)
    },
    async onSelectattention() {
      this.$emit("inv_sotab_attentioncus", this.attention);
    },
    async onSelectcontact_position() {
      this.$emit("inv_sotab_contact_positioncus", this.contact_position);
    },
    async onSelectvat_type() {
      this.$emit("inv_sotab_vat_type", this.vat_type);
    },

    setupAlertDialog(status, titleSo, messageSo, text_colorSo) {
      this.titleSo = titleSo;
      this.messageSo = messageSo;
      this.dialogAddSo = status;
      this.text_colorSo = text_colorSo;
    },
  },

  beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.v-messages__message {
  color: red !important;
}
</style>
